import React from 'react';

import InfoItem from '../InfoItem/InfoItem';
import type { InfoItemProps } from '../InfoItem/InfoItem';

interface InfoItemsListProps {
  infoItems: InfoItemProps[];
}

const InfoItemsList: React.FC<InfoItemsListProps> = ({ infoItems }) => (
  <>
    {infoItems.map(({ icon, infoDetails }, i) => (
      <InfoItem
        icon={icon}
        infoDetails={infoDetails}
        key={`InfoItem-${infoDetails[0].label}-${i}`}
      />
    ))}
  </>
);

export default InfoItemsList;
